import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

function getSDM18HCLs() {
    return dispatch => {
        return apiCaller
            .call(api.getAllSDM18HCLs())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_SDM18HCLS',
                        SDM18HCLs: data.SDM18HCLs
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHESDM18HCLs - ', error);
                throw error;
            });
    };
}
function getSDM18HCLDetails(SDM18HCLId) {
    return dispatch => {
        return apiCaller
            .call(api.getOneSDM18HCLDetails(SDM18HCLId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_SDM18HCL_DETAILS',
                        SDM18HCLId: data.SDM18HCLDetails.macAddress,
                        SDM18HCLDetails: data.SDM18HCLDetails
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHESDM18HCLDetails - ', error);
                throw error;
            });
    };
}
function refreshSDM18HCLStatus(SDM18HCLMac) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductCheckStatus('SDM18HCL', SDM18HCLMac)
            .catch(error => {
                Logger.log('dataActions: refreshMyFHESDM18HCLStatus - ', error);
                throw error;
            });
    };
}
function dissociateSDM18HCLUser(SDM18HCLMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUser('SDM18HCL', SDM18HCLMac, userId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM18HCLUser - ', error);
                throw error;
            });
    };
}
function dissociateSDM18HCLUserAndSwitchMaster(SDM18HCLMac, userId, masterId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUserAndSwitchMaster('SDM18HCL', SDM18HCLMac, userId, masterId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM18HCLUserAndSwitchMaster - ', error);
                throw error;
            });
    };
}
function switchSDM18HCLMaster(SDM18HCLMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductMasterSwitch('SDM18HCL', SDM18HCLMac, userId)
            .catch(error => {
                Logger.log('dataActions: switchMyFHESDM18HCLMaster - ', error);
                throw error;
            });
    };
}

export {
    getSDM18HCLs,
    getSDM18HCLDetails,
    refreshSDM18HCLStatus,
    dissociateSDM18HCLUser,
    dissociateSDM18HCLUserAndSwitchMaster,
    switchSDM18HCLMaster
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM18HCL/actions.js